/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Components_Offercard_Openoffer2Inputs */

const id_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buka penawaran ${i?.title}`)
};

const ms_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buka tawaran ${i?.title}`)
};

const da_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Åbn tilbud ${i?.title}`)
};

const de_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Angebot öffnen ${i?.title}`)
};

const en_us2_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open offer ${i?.title}`)
};

const es_es2_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir oferta ${i?.title}`)
};

const es_mx2_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir oferta ${i?.title}`)
};

const fil_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buksan ang offer ${i?.title}`)
};

const fr_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ouvrir l'offre ${i?.title}`)
};

const it_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apri offerta ${i?.title}`)
};

const hu_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajánlat megnyitása: ${i?.title}`)
};

const nl_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open aanbod ${i?.title}`)
};

const no_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Åpne tilbud ${i?.title}`)
};

const pl_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Otwórz ofertę ${i?.title}`)
};

const pt_br2_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open offer ${i?.title}`)
};

const pt_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir oferta ${i?.title}`)
};

const ro_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deschide oferta ${i?.title}`)
};

const fi_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avaa tarjous ${i?.title}`)
};

const sv_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Öppna erbjudande ${i?.title}`)
};

const vi_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mở ưu đãi ${i?.title}`)
};

const tr_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} teklifini aç`)
};

const cs_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Otevřít nabídku ${i?.title}`)
};

const bg_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отваряне на оферта ${i?.title}`)
};

const ru_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Открыть предложение ${i?.title}`)
};

const uk_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Відкрити пропозицію ${i?.title}`)
};

const ar_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`فتح العرض ${i?.title}`)
};

const hi_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑफ़र खोलें ${i?.title}`)
};

const th_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เปิดข้อเสนอ ${i?.title}`)
};

const ja_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オファー ${i?.title} を開く`)
};

const zh_cn2_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open offer ${i?.title}`)
};

const zh_hant1_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open offer ${i?.title}`)
};

const ko_components_offercard_openoffer2 = /** @type {(inputs: Components_Offercard_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open offer ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Open offer {title}" |
*
* @param {Components_Offercard_Openoffer2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_offercard_openoffer2 = /** @type {((inputs: Components_Offercard_Openoffer2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Offercard_Openoffer2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_offercard_openoffer2(inputs)
	if (locale === "ms") return ms_components_offercard_openoffer2(inputs)
	if (locale === "da") return da_components_offercard_openoffer2(inputs)
	if (locale === "de") return de_components_offercard_openoffer2(inputs)
	if (locale === "en-US") return en_us2_components_offercard_openoffer2(inputs)
	if (locale === "es-ES") return es_es2_components_offercard_openoffer2(inputs)
	if (locale === "es-MX") return es_mx2_components_offercard_openoffer2(inputs)
	if (locale === "fil") return fil_components_offercard_openoffer2(inputs)
	if (locale === "fr") return fr_components_offercard_openoffer2(inputs)
	if (locale === "it") return it_components_offercard_openoffer2(inputs)
	if (locale === "hu") return hu_components_offercard_openoffer2(inputs)
	if (locale === "nl") return nl_components_offercard_openoffer2(inputs)
	if (locale === "no") return no_components_offercard_openoffer2(inputs)
	if (locale === "pl") return pl_components_offercard_openoffer2(inputs)
	if (locale === "pt-BR") return pt_br2_components_offercard_openoffer2(inputs)
	if (locale === "pt") return pt_components_offercard_openoffer2(inputs)
	if (locale === "ro") return ro_components_offercard_openoffer2(inputs)
	if (locale === "fi") return fi_components_offercard_openoffer2(inputs)
	if (locale === "sv") return sv_components_offercard_openoffer2(inputs)
	if (locale === "vi") return vi_components_offercard_openoffer2(inputs)
	if (locale === "tr") return tr_components_offercard_openoffer2(inputs)
	if (locale === "cs") return cs_components_offercard_openoffer2(inputs)
	if (locale === "bg") return bg_components_offercard_openoffer2(inputs)
	if (locale === "ru") return ru_components_offercard_openoffer2(inputs)
	if (locale === "uk") return uk_components_offercard_openoffer2(inputs)
	if (locale === "ar") return ar_components_offercard_openoffer2(inputs)
	if (locale === "hi") return hi_components_offercard_openoffer2(inputs)
	if (locale === "th") return th_components_offercard_openoffer2(inputs)
	if (locale === "ja") return ja_components_offercard_openoffer2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_offercard_openoffer2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_offercard_openoffer2(inputs)
	return ko_components_offercard_openoffer2(inputs)
});
export { components_offercard_openoffer2 as "components.offerCard.openOffer" }